// DS: DS6.1 - Option Semantics (for use in select-style menus)
import React, { type HTMLAttributes } from 'react';
import ListItemContent from '../../legos/ListItemContent';
import {
  type CommonListItemAPI,
  EffectStrength,
  useListItem,
} from '../../common';

export interface Props
  extends CommonListItemAPI,
    Omit<HTMLAttributes<HTMLDivElement>, 'prefix' | 'aria-selected' | 'role'> {
  highlighted?: boolean;
}

/**
 * This is a ListItem with `role="option"` semantics. We expect it to be contained in an element with `role="combobox"`,
 * so only use this if you know how that works (https://w3c.github.io/aria/#combobox).
 */
const ListItemOption: React.FC<Props> = unfilteredProps => {
  const {
    rootProps: { checked, ...restRootProps },
    contentProps,
  } = useListItem(unfilteredProps, { checked: EffectStrength.Weak });

  return (
    <div role="option" aria-selected={checked} {...restRootProps}>
      <ListItemContent {...contentProps} />
    </div>
  );
};

ListItemOption.displayName = 'ListItemOption';

export default ListItemOption;
